import { useCurrentUserName } from './useCurrentUserName';

/**
 * The current user's reviewer name for approval operations: the signed-in
 * user's display name, or 'unknown' where nobody is signed in, since an
 * approval must always carry a reviewer.
 */
export function useReviewer(): string {
    return useCurrentUserName() ?? 'unknown';
}
